import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StepperStep from '../../base/StepperStep';
import Styles from './Stepper.styles';

const Container = styled.div`${Styles.container}`;
const Line = styled.div`${Styles.line}`;

/**
 * Stepper component
 * @property {Object} props - component props
 * @returns {JSX}
 */
const Stepper = ({ activeIndex, translations,  locale, selectorItem, currentStep, editTicket, editParking, isLoading, action, cart}) => {
  const continueCart = () => {
    window.location.href=`/${locale}/cart`;
  }
  
  const openAddOns = () => {
    window.location.href=`/${locale}/addOns`;
  }

  const openLot = () => {
    window.location.href=`/${locale}/lot`;
  }

  const openHome = () => {
    window.location.href=`/${locale}/`;
  }

  const openConfigTicket = () => {
    window.location.href=`/${locale}/configTicket`;
  }
  
  const openPersonalInfo = () => {
    window.location.href=`/${locale}/personalInfo`;
  }

  

return <Container>
    <StepperStep style={{ flex: 1 }} label={translations.ticketStep} stepNumber={1} showLabels={true}   selected={activeIndex === 1}  enabled={currentStep>=1 } onClick={selectorItem === 'Parking' ? editParking : openHome } />
    <Line />
    <StepperStep style={{ flex: 2 }} label={translations.passengerInformation} stepNumber={2} showLabels={true}  selected={activeIndex === 2} enabled={currentStep>=2} action={action}  onClick={selectorItem === 'Parking' ? openPersonalInfo : editTicket }  />
    <Line />
    <StepperStep style={{ flex: 1 }} label={translations.addOns} stepNumber={3} showLabels={true} selected={activeIndex === 3} enabled={currentStep>=3} onClick={openAddOns}/>
    <Line />
    <StepperStep style={{ flex: 1 }} label={translations.checkout} stepNumber={4} showLabels={true} selected={activeIndex === 4} enabled={true}  onClick={continueCart}/>

  </Container>
}

Stepper.propTypes = {
  activeIndex: PropTypes.number,
  translations: PropTypes.object,
  enable: PropTypes.bool
};

export default Stepper;
